import { AppState } from '@nxsys/store';
import { IRELAND, UNITED_KINGDOM } from '@nxsys/store/constants/keys';
import { useSelector } from 'react-redux';
import DashboardIreland from './DashboardIreland';
import DashboardUK from './DashboardUK';
import DashboardUmbrella from './DashboardUmbrella';

const Dashboard = () => {
  const { payrollCountry, isBureau } = useSelector(
    (state: AppState) => state.appStore,
  );

  if (!isBureau) {
    // NX-6278: key by country so a UK ↔ Ireland switch remounts the
    // dashboard; its cards only fetch on mount.
    return <DashboardUmbrella key={payrollCountry} />;
  } else if (payrollCountry === UNITED_KINGDOM) {
    return <DashboardUK />;
  } else if (payrollCountry === IRELAND) {
    return <DashboardIreland />;
  }
  return <></>;
};

export default Dashboard;
